

// // InvoiceApi.js
// import axios from "axios";
// import Cookies from "js-cookie";

// const API_BASE_URL = "http://localhost:8080/api";

// const apiClient = axios.create({
//   baseURL: API_BASE_URL,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// // Axios interceptor to add Authorization and Office-Code headers
// apiClient.interceptors.request.use(
//   config => {
//     const authToken = Cookies.get("authToken");
//     const officeCode = Cookies.get("officeCode") || "DIAMOND-META" ;
//     console.log("officecode",officeCode);
//     if (authToken) {
//       config.headers.Authorization = `Bearer ${authToken}`;
//     }
//     if (officeCode) {
//       config.headers["Office-Code"] = officeCode;
//     }
//     console.log("Request Headers:", config.headers);
//     return config;
//   },
//   error => Promise.reject(error)
// );

// const invoiceApi = {
//   createInvoice: payload =>
//     apiClient.post("/invoices", payload).then(res => res.data),

//   detailedSearch: (searchRequest, page, size) =>
//     apiClient
//       .post(`/invoices/details/detailed-search?page=${page}&size=${size}`, searchRequest)
//       .then(res => res.data),

//   getAllInvoices: () =>
//     apiClient.get("/invoices").then(res => res.data),

//   getInvoiceByNumber: invoiceNumber =>
//     apiClient.get(`/invoices/number/${invoiceNumber}`).then(res => res.data),

//   updateInvoice: (id, payload) =>
//     apiClient.put(`/invoices/${id}`, payload).then(res => res.data),

//   deleteInvoice: id =>
//     apiClient.delete(`/invoices/${id}`).then(res => res.data),
// };

// export { invoiceApi };
// src/features/ACS-Dashboard-Modules/Invoice/InvoiceApi.js
import axios from "axios";
import Cookies from "js-cookie";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL+"/api";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});


// apiClient.interceptors.request.use(
//   config => {
//     const authToken = Cookies.get("authToken");
   
//     const officeCode = Cookies.get("officeCodes");

//     console.log("Office-Code cookie:", officeCode);


//     if (authToken) config.headers.Authorization = `Bearer ${authToken}`;
//     config.headers["Office-Code"] = officeCode;
//     // console.log("  → headers after auth:", config.headers);
//     return config;
//   },
//   err => Promise.reject(err)
// );

apiClient.interceptors.request.use(
  config => {
    const authToken = Cookies.get("authToken");

    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }

    // ✅ Only set Office-Code if caller did NOT provide one
    if (!config.headers["Office-Code"]) {
      const officeCodes = Cookies.get("officeCodes");
      config.headers["Office-Code"] = officeCodes;
    }

    return config;
  },
  err => Promise.reject(err)
);


const invoiceApi = {
  createInvoice: payload =>
    apiClient.post("/invoices", payload).then(res => res.data),

  getAllInvoices: () =>
    apiClient.get("/invoices").then(res => res.data),

  getInvoiceByNumber: invoiceNumber =>
    apiClient.get(`/invoices/number/${invoiceNumber}`).then(res => res.data),

    getInvoiceById: id =>
    apiClient.get(`/invoices/${id}`).then(res => res.data),

  // updateInvoice: (id, dto) =>
  //   apiClient.put(`/invoices/${id}`, dto).then(res => res.data),
    approveInvoice: (id, dto, officeCode = null) => {
        const headers = {};
        if (officeCode) {
            headers["Office-Code"] = officeCode;
        }
        return apiClient.put(`/invoices/update-invoice/${id}`, dto, { headers }).then(res => res.data);
    },

  updateInvoice: (id, dto, officeCode = null) => {
    const headers = {};
    if (officeCode) {
      headers["Office-Code"] = officeCode;
    }
    return apiClient.put(`/invoices/${id}`, dto, { headers }).then(res => res.data);
  },

    getAutoApprovalConfig: (shipper) =>
    apiClient
      .get(`/auto-approval-config`, { params: { shipper, carrier: 'null' } })
      .then(res => res.data),


  deleteInvoice: id =>
    apiClient.delete(`/invoices/${id}`).then(res => res.data),

  // ——— DETAILED SEARCH ———
  detailedSearch: async (searchRequest, page = 0, size = 10) => {
    const url = `/invoices/details/detailed-search?page=${page}&size=${size}`;

    //console.log("[InvoiceApi] → POST", url, "body:", searchRequest);


    try {
      const { data } = await apiClient.post(url, searchRequest);
      console.log("[InvoiceApi] ← 200 OK", data);
      return data;
    } catch (err) {
      if (err.response) {
        console.error(
          "[InvoiceApi] ←",
          err.response.status,
          err.response.data
        );
      } else {
        console.error("[InvoiceApi] network error:", err);
      }
      throw err;
    }
  },
};

export { invoiceApi };
